<template>
  <schedule-container-form
    :edit="edit"
    :entityType="entityType"
    :entityId="entityId"
    @added="backToList"
    @updated="backToList"
    @cancel="backToList"
  />
</template>

<script>
import ScheduleContainerForm from '@/components/forms/ScheduleContainerForm';
import { TableName } from '@/enums/tableName.enum';

// @vuese
// Formularz do edycji/dodawania harmonogramów
// @group Schedule
export default {
  props: {
    // Czy formularz edycji
    edit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    ScheduleContainerForm
  },
  methods: {
    // @vuese
    // Powrót do listy ustawień
    backToList() {
      this.$router.push({ name: 'teamSchedules' });
    }
  },
  computed: {
    entityType() {
      return TableName.Team;
    },
    entityId() {
      return this.$route.params.teamId.toString();
    }
  }
};
</script>